import { list } from "./list";

export const PersonTypesEndpoint = {
  list,
};
